export const CFP_FILE_TYPES = {
  cfpText: 'CFP TEXT',
  cfpPdf: 'CFP PDF',
  xmlArinc: 'XML ARINC',
  xmlFd: 'XML FD'
}

export const CFP_TAG_TYPE = {
  external: 'success',
  manual: 'warning',
  fromTxt: 'info',
  fromPdf: 'info',
  fromArinc: 'info'
}

export const CFP_VALID_EXTENSIONS = {
  cfpText: ['.txt'],
  cfpPdf: ['.pdf'],
  xmlArinc: ['.xml'],
  xmlFd: ['.xml']
}

export const DATE_FORMATS = {
  DATETIME_FULL: 'HH:mm, DD.MM.YYYY',
  DATETIME_SHORT: 'HH:mm, DD.MM.YY',
  DATE_FULL: 'DD.MM.YYYY',
  DATE_ISO: 'YYYY-MM-DD'
}
